export const codeMaskList = [{
    "code": "DZ", "mask": "00000"
}, {
    "code": "AS", "mask": "00000"
}, {
    "code": "AR", "mask": "0000"
}, {
    "code": "AM", "mask": "000000"
}, {
    "code": "AU", "mask": "0000"
}, {
    "code": "AT", "mask": "0000"
}, {
    "code": "AZ", "mask": "000000"
}, {
    "code": "BD", "mask": "0000"
}, {
    "code": "BY", "mask": "000000"
}, {
    "code": "BE", "mask": "0000"
}, {
    "code": "BA", "mask": "00000"
}, {
    "code": "BR", "mask": "000000000"
}, {
    "code": "BN", "mask": "SS0000"
}, {
    "code": "BG", "mask": "0000"
}, {
    "code": "CA", "mask": "S0S 0S0"
}, {
    "code": "IC", "mask": "00000"
}, {
    "code": "CN", "mask": "000000"
}, {
    "code": "HR", "mask": "00000"
}, {
    "code": "CU", "mask": "00000"
}, {
    "code": "CY", "mask": "0000"
}, {
    "code": "CZ", "mask": "000 00"
}, {
    "code": "DK", "mask": "0000"
}, {
    "code": "EE", "mask": "00000"
}, {
    "code": "FI", "mask": "00000"
}, {
    "code": "FR", "mask": "00000"
}, {
    "code": "GF", "mask": "00000"
}, {
    "code": "GE", "mask": "0000"
}, {
    "code": "DE", "mask": "00000"
}, {
    "code": "GR", "mask": "000 00"
}, {
    "code": "GL", "mask": "0000"
}, {
    "code": "GP", "mask": "00000"
}, {
    "code": "GU", "mask": "00000"
}, {
    "code": "GG", "mask": "SS0 0SS"
}, {
    "code": "HU", "mask": "0000"
}, {
    "code": "IS", "mask": "000"
}, {
    "code": "IN", "mask": "000000"
}, {
    "code": "ID", "mask": "00000"
},{
    "code": "IL", "mask": "0000000"
}, {
    "code": "IT", "mask": "00000"
}, {
    "code": "JP", "mask": "000-0000"
}, {
    "code": "JE", "mask": "SS0 0SS"
}, {
    "code": "KZ", "mask": "000000"
}, {
    "code": "KE", "mask": "00000"
}, {
    "code": "KR", "mask": "00000"
}, {
    "code": "KG", "mask": "000000"
}, {
    "code": "LV", "mask": "0000"
}, {
    "code": "LI", "mask": "0000"
}, {
    "code": "LT", "mask": "00000"
}, {
    "code": "LU", "mask": "0000"
}, {
    "code": "MK", "mask": "0000"
}, {
    "code": "MG", "mask": "000"
}, {
    "code": "MY", "mask": "00000"
}, {
    "code": "MV", "mask": "99999"
}, {
    "code": "MT", "mask": "9999999999"
}, {
    "code": "MH", "mask": "00000"
}, {
    "code": "MQ", "mask": "00000"
}, {
    "code": "MX", "mask": "00000"
}, {
    "code": "MD", "mask": "0000"
}, {
    "code": "MC", "mask": "00000"
}, {
    "code": "MN", "mask": "000000"
}, {
    "code": "MA", "mask": "00000"
}, {
    "code": "NL", "mask": "0000 SS"
}, {
    "code": "NO", "mask": "0000"
}, {
    "code": "PK", "mask": "00000"
}, {
    "code": "PH", "mask": "0000"
}, {
    "code": "PL", "mask": "00-000"
}, {
    "code": "PT", "mask": "9999999999"
}, {
    "code": "PR", "mask": "00000"
}, {
    "code": "RE", "mask": "00000"
}, {
    "code": "RO", "mask": "000000"
}, {
    "code": "RU", "mask": "000000"
}, {
    "code": "MP", "mask": "00000"
}, {
    "code": "CS", "mask": "00000"
}, {
    "code": "SG", "mask": "000000"
}, {
    "code": "SK", "mask": "000 00"
}, {
    "code": "SI", "mask": "0000"
}, {
    "code": "ZA", "mask": "0000"
}, {
    "code": "ES", "mask": "00000"
}, {
    "code": "XY", "mask": "00000"
}, {
    "code": "SZ", "mask": "A000"
}, {
    "code": "SE", "mask": "000 00"
}, {
    "code": "CH", "mask": "0000"
}, {
    "code": "TW", "mask": ""
}, {
    "code": "TJ", "mask": "000000"
}, {
    "code": "TH", "mask": "00000"
}, {
    "code": "TR", "mask": "00000"
}, {
    "code": "TM", "mask": "000000"
}, {
    "code": "UA", "mask": "00000"
}, {
    "code": "UK", "mask": ""
}, {
    "code": "US", "mask": "99999-9999"
}, {
    "code": "UY", "mask": "00000"
}, {
    "code": "KH", "mask": "00000"
}, {
    "code": "UZ", "mask": "000000"
}, { "code": "VI", "mask": "00000" }

];